import { JSX } from 'react';

import {
  ICustomRenderCellJSXProps,
  IListViewTableColumns,
  IListViewTablePagination,
  Order,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { spacing } from '~/src/dash/publicaUI';
import {
  InventoryRulesModalLink,
  NameWithDefault,
} from '~/src/dash/views/inventory-rules-v2/common';

export interface ICustomDataListConfig {
  cypressClassName: string;
  defaultState: {
    activeColumnKeys: string[];
    orderDirection: Order;
    orderBy: TCustomDataListKey;
    page: number;
    rowsPerPage: RowsPerPage;
  };
  timezone: string;
  columns: IListViewTableColumns;
  table: IListViewTablePagination;
  activeColumnKeys: string[];
  columnSelector: {
    resetKeys: string[];
  };
}

export const customDataListConfig: ICustomDataListConfig = {
  cypressClassName: 'custom-data-list',
  defaultState: {
    activeColumnKeys: [
      'AssociatedInventoryRules',
      'Custom5',
      'Custom6',
      'Custom7',
      'Custom8',
      'Custom9',
      'Custom10',
      'Custom11',
      'Custom12',
      'Custom13',
      'Custom14',
      'Custom15',
      'Custom16',
      'Custom17',
      'Custom18',
    ],
    orderDirection: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 25,
  },
  timezone: 'UTC',
  activeColumnKeys: [
    'AssociatedInventoryRules',
    'Custom5',
    'Custom6',
    'Custom7',
    'Custom8',
    'Custom9',
    'Custom10',
    'Custom11',
    'Custom12',
    'Custom13',
    'Custom14',
    'Custom15',
    'Custom16',
    'Custom17',
    'Custom18',
  ],
  columns: {
    ID: {
      formatValue: (value: number) => value.toString(),
      isHidden: true,
      isSearchable: false,
      key: 'ID',
      label: 'ID',
      requestKey: 'ID',
      responseKey: 'ID',
      valueType: 'string',
    },
    Name: {
      cellJSX: (props: ICustomRenderCellJSXProps): JSX.Element =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        NameWithDefault({ ...props, fallbackName: 'UnnamedCustomData' }),
      cellRenderType: 'name',
      defaultOrderDirection: 'asc',
      headerRenderType: 'name',
      headerStyle: {
        width: '40%',
      },
      cellStyle: {
        width: '40%',
      },
      isSearchable: true,
      key: 'Name',
      label: 'Name',
      tKey: 'Name',
      requestKey: 'Name',
      responseKey: 'Name',
      valueType: 'string',
      orderByKey: 'Name',
    },
    AssociatedInventoryRules: {
      cellJSX: InventoryRulesModalLink,
      headerRenderType: 'number',
      cellRenderType: 'number',
      headerStyle: {
        textAlign: 'left',
        paddingLeft: spacing.base,
      },
      cellStyle: {
        textAlign: 'left',
        paddingLeft: spacing.base,
      },
      key: 'AssociatedInventoryRules',
      label: 'Associated Inventory Rules',
      requestKey: 'AssociatedInventoryRules',
      responseKey: 'AssociatedInventoryRules',
      valueType: 'number',
    },
    Custom5: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom5',
      tKey: 'Custom5',
      label: 'Custom 5',
      requestKey: '',
      responseKey: 'Custom5',
      valueType: 'string',
      orderByKey: 'Custom5',
    },
    Custom6: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom6',
      tKey: 'Custom6',
      label: 'Custom 6',
      requestKey: '',
      responseKey: 'Custom6',
      valueType: 'string',
      orderByKey: 'Custom6',
    },
    Custom7: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom7',
      tKey: 'Custom7',
      label: 'Custom 7',
      requestKey: '',
      responseKey: 'Custom7',
      valueType: 'string',
      orderByKey: 'Custom7',
    },
    Custom8: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom8',
      tKey: 'Custom8',
      label: 'Custom 8',
      requestKey: '',
      responseKey: 'Custom8',
      valueType: 'string',
      orderByKey: 'Custom8',
    },
    Custom9: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom9',
      tKey: 'Custom9',
      label: 'Custom 9',
      requestKey: '',
      responseKey: 'Custom9',
      valueType: 'string',
      orderByKey: 'Custom9',
    },
    Custom10: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom10',
      tKey: 'Custom10',
      label: 'Custom 10',
      requestKey: '',
      responseKey: 'Custom10',
      valueType: 'string',
      orderByKey: 'Custom10',
    },
    Custom11: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom11',
      tKey: 'Custom11',
      label: 'Custom 11',
      requestKey: '',
      responseKey: 'Custom11',
      valueType: 'string',
      orderByKey: 'Custom11',
    },
    Custom12: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom12',
      tKey: 'Custom12',
      label: 'Custom 12',
      requestKey: '',
      responseKey: 'Custom12',
      valueType: 'string',
      orderByKey: 'Custom12',
    },
    Custom13: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom13',
      tKey: 'Custom13',
      label: 'Custom 13',
      requestKey: '',
      responseKey: 'Custom13',
      valueType: 'string',
      orderByKey: 'Custom13',
    },
    Custom14: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom14',
      tKey: 'Custom14',
      label: 'Custom 14',
      requestKey: '',
      responseKey: 'Custom14',
      valueType: 'string',
      orderByKey: 'Custom14',
    },
    Custom15: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom15',
      tKey: 'Custom15',
      label: 'Custom 15',
      requestKey: '',
      responseKey: 'Custom15',
      valueType: 'string',
      orderByKey: 'Custom15',
    },
    Custom16: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom16',
      tKey: 'Custom16',
      label: 'Custom 16',
      requestKey: '',
      responseKey: 'Custom16',
      valueType: 'string',
      orderByKey: 'Custom16',
    },
    Custom17: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom17',
      tKey: 'Custom17',
      label: 'Custom 17',
      requestKey: '',
      responseKey: 'Custom17',
      valueType: 'string',
      orderByKey: 'Custom17',
    },
    Custom18: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'Custom18',
      tKey: 'Custom18',
      label: 'Custom 18',
      requestKey: '',
      responseKey: 'Custom18',
      valueType: 'string',
      orderByKey: 'Custom18',
    },
  },
  columnSelector: {
    resetKeys: [
      'AssociatedInventoryRules',
      'Custom5',
      'Custom6',
      'Custom7',
      'Custom8',
      'Custom9',
      'Custom10',
      'Custom11',
      'Custom12',
      'Custom13',
      'Custom14',
      'Custom15',
      'Custom16',
      'Custom17',
      'Custom18',
    ],
  },
  table: {
    order: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 25,
  },
} as unknown as ICustomDataListConfig;

export type TCustomDataListKey = keyof typeof customDataListConfig.columns;
